import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock } from 'lucide-react';
export function SolutionSection() {
  const outcomes = ['Todo queda respaldado en un historial permanente', 'Busca por fecha, persona, palabra clave o categoría', 'Recibe resúmenes automáticos de avances y problemas', 'Genera informes PDF sin armar Word manualmente'];
  return <section id="solucion" className="scroll-mt-20 py-12 sm:py-16 bg-gray-50" data-id="element-261">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-263">
          {/* Left column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-264">
            <div className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-265">
              LA SOLUCIÓN
            </div>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 mb-5 sm:mb-6 leading-tight tracking-tight" data-id="element-266">
              Tu WhatsApp se transforma en historial de obra.
            </h2>

            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed" data-id="element-267">
              Tu equipo sigue usando WhatsApp. Obra Digital ordena todo
              automáticamente y lo deja listo para buscar, revisar y reportar.
            </p>

            <div className="space-y-2.5 sm:space-y-3 mb-6 sm:mb-8" data-id="element-268">
              {outcomes.map((outcome, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-269">
                  <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-270" />
                  <p className="text-sm sm:text-base text-gray-700 font-medium" data-id="element-271">
                    {outcome}
                  </p>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl border border-blue-100" data-id="element-272">
              <Lock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-273" />
              <p className="text-sm font-medium text-blue-900" data-id="element-274">
                Aunque alguien borre una foto, cambie de celular o desaparezca
                el grupo, el historial sigue disponible.
              </p>
            </motion.div>
          </motion.div>

          {/* Right column - Before/After */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-6" data-id="element-275">
            {/* Before */}
            <div className="relative bg-white rounded-2xl p-6 border border-gray-200 shadow-lg" data-id="element-276">
              <div className="absolute -top-3 left-6 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-277">
                Antes
              </div>

              <div className="relative h-[240px] bg-gradient-to-br from-gray-100 to-gray-50 rounded-xl overflow-hidden" data-id="element-278">
                <div className="absolute top-4 left-4 w-20 h-20 bg-gray-300 rounded-lg shadow-md transform -rotate-12" data-id="element-279" />
                <div className="absolute top-8 right-6 w-16 h-16 bg-gray-300 rounded-lg shadow-md transform rotate-6" data-id="element-280" />
                <div className="absolute bottom-12 left-8 w-24 h-24 bg-gray-300 rounded-lg shadow-md transform rotate-12" data-id="element-281" />
                <div className="absolute bottom-6 right-4 w-20 h-20 bg-gray-300 rounded-lg shadow-md transform -rotate-6" data-id="element-282" />

                <div className="absolute bottom-4 left-4 bg-white rounded-xl rounded-bl-none px-3 py-2 shadow-lg max-w-[200px]" data-id="element-283">
                  <p className="text-xs text-gray-600" data-id="element-284">
                    "¿Dónde quedó la foto de la filtración?"
                  </p>
                </div>
              </div>
            </div>

            {/* After */}
            <div className="relative bg-white rounded-2xl p-6 border border-blue-200 shadow-lg" data-id="element-285">
              <div className="absolute -top-3 left-6 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-286">
                Después
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-white rounded-xl p-5 border border-blue-100" data-id="element-287">
                <div className="mb-4 pb-3 border-b border-gray-200" data-id="element-288">
                  <h4 className="text-sm font-bold text-gray-900" data-id="element-289">
                    Resumen semanal · Proyecto Centro
                  </h4>
                </div>

                <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-290">
                  <div className="bg-white rounded-lg p-2 border border-gray-200 text-center" data-id="element-291">
                    <div className="text-lg font-bold text-blue-600" data-id="element-292">12</div>
                    <div className="text-[10px] text-gray-600" data-id="element-293">Avances</div>
                  </div>
                  <div className="bg-white rounded-lg p-2 border border-gray-200 text-center" data-id="element-294">
                    <div className="text-lg font-bold text-green-600" data-id="element-295">3</div>
                    <div className="text-[10px] text-gray-600" data-id="element-296">Decisiones</div>
                  </div>
                  <div className="bg-white rounded-lg p-2 border border-gray-200 text-center" data-id="element-297">
                    <div className="text-lg font-bold text-amber-600" data-id="element-298">2</div>
                    <div className="text-[10px] text-gray-600" data-id="element-299">Problemas</div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-300">
                  <div className="flex items-start gap-2" data-id="element-301">
                    <div className="w-2 h-2 rounded-full bg-green-500 mt-1.5 flex-shrink-0" data-id="element-302" />
                    <p className="text-xs text-gray-700" data-id="element-303">
                      Avance del 18% en pintura interior
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-304">
                    <div className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 flex-shrink-0" data-id="element-305" />
                    <p className="text-xs text-gray-700" data-id="element-306">
                      Cambio de proveedor aprobado
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-307">
                    <div className="w-2 h-2 rounded-full bg-amber-500 mt-1.5 flex-shrink-0" data-id="element-308" />
                    <p className="text-xs text-gray-700" data-id="element-309">
                      2 problemas pendientes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}